import { render, staticRenderFns } from "./ListAddMenu.vue?vue&type=template&id=22fc1749&scoped=true&"
import script from "./ListAddMenu.vue?vue&type=script&lang=js&"
export * from "./ListAddMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListAddMenu.vue?vue&type=style&index=0&id=22fc1749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc1749",
  null
  
)

export default component.exports